// File: cgp-idle-dialog.module.ts
// Author: Joseph M Diaz
// Date: 6/8/2017
// Desc: CGP Idle / Token Refresh timers and idle dialog.
// Other Contributors:

import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

import { CgpIdleService } from './cgp-idle.service';
import { CgpIdleDialogComponent } from './cgp-idle-dialog/cgp-idle-dialog.component';

@NgModule({
    imports: [
        MatDialogModule, MatButtonModule
    ],
    exports: [
        CgpIdleDialogComponent
    ],
    declarations: [
        CgpIdleDialogComponent
    ],
    providers: [
        CgpIdleService
    ]
})
export class CgpIdleModule { }
